import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import Landing from './pages/Landing';
import Waiver from './pages/Waiver';
import Admin from './pages/Admin';
import Services from './pages/Services';
import HowItWorks from './pages/HowItWorks';
import Profile from './pages/Profile';
import AppNav from './components/AppNav';
import './App.css';

function Shell() {
  const location = useLocation();
  // Hide nav mid-signature-flow to keep the kiosk focused; show on all other routes.
  const hideNav = false; // keep nav visible on all pages per requirement
  return (
    <>
      {!hideNav && <AppNav />}
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/waiver" element={<Waiver />} />
        <Route path="/services" element={<Services />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
      <Toaster
        position="top-center"
        richColors
        closeButton
        toastOptions={{
          style: {
            fontFamily: 'Manrope, sans-serif',
            borderRadius: '16px',
          },
        }}
      />
    </div>
  );
}

export default App;
